export default __webpack_public_path__ + "static/media/icon-pickup.6c2d9051.svg";